import {getDistributorList} from "@/api/Distributor"

export default {
  addDistributor({ commit }, distributor) {
    return new Promise((resolve, reject) => {
      commit('ADD_DISTRIBUTOR', distributor)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsDistributor({ commit },payload) {
    return new Promise((resolve, reject) => {
      getDistributorList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_DISTRIBUTOR', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateDistributor({ commit }, distributor) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_DISTRIBUTOR', distributor)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeDistributor({ commit }, distributorId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_DISTRIBUTOR', distributorId)
          resolve();
    })
  }
};